import React from 'react';
import { useTranslation } from 'next-i18next';
import { ShuffleRounded } from '@mui/icons-material';
import BaseControlButton, { IControlButtonProps } from '../control-base';

const ShuffleControlButton: React.FC<IControlButtonProps> = (props) => {
  const { className = '', disabled = false, onClick = () => {} } = props;

  const { t: tButtons } = useTranslation('buttons');

  return (
    <BaseControlButton
      className={className}
      icon={<ShuffleRounded fontSize="inherit" />}
      text={tButtons('shuffle')}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default ShuffleControlButton;
